<template>
    <main-content>
        <!-- <div v-if="!activeGateways().has_gateway">
            <div>
                <p class="font-weight-bolder text-center bg-white p-3" :style="{fontSize: '15px'}">
                    {{ $t('message.no_gateway') }}
                    <router-link
                        class="btn btn-success d-block w-25 text-center align-content-center mx-auto mt-3"
                        to="/gateways"> {{ $t('btn.create_gateway') }}</router-link>
                </p>
            </div>
        </div>
        <div v-else-if="!activeGateways().has_active_gateway">
            <div>
                <p class="font-weight-bolder text-center bg-white p-3" :style="{fontSize: '15px'}">
                    {{ $t('message.no_active_gateway') }}
                </p>
            </div>
        </div>
        <div v-else-if="gateway_didnt_set_in_pardakht_shakhsi">
            <div>
                <p class="font-weight-bolder text-center bg-white p-3" :style="{fontSize: '15px'}">
                    {{ $t('message.gateway_didnt_set_in_pardakht_shakhsi') }}
                </p>
            </div>
        </div>
        <div v-else-if="gateway_which_set_in_pardakht_shakhsi_is_not_active">
            <div>
                <p class="font-weight-bolder text-center bg-white p-3" :style="{fontSize: '15px'}">
                    {{ $t('message.gateway_which_set_in_pardakht_shakhsi_is_not_active') }}
                </p>
            </div>
        </div> -->
      <div>
        <page-title
            class="my-3"
            title_text="درخواست پول"
            icon="money_request"
        >
        </page-title>
        <money-request-form
                            :submitSingleRequest="submitSingleRequest"
                            :submitGroupRequest="submitGroupRequest"
        >
        </money-request-form>
        <div class="alert alert-danger my-3" v-if="showErr">
            جهت ایجاد درخواست پول، ابتدا درگاه اینترنتی و یا پرداخت شناسه‌دار ثبت نمایید.
        </div>
      </div>

    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {gatewayTypes} from "@/constants/gatewayTypes";
import Form from './components/form'
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {mapGetters} from "vuex";
import {moneyRequestService} from "@/common/api.service";
import PageTitle from "@/components/main/components/pageTitle";
import { gatewayStatus } from '@/constants/gatewayStatus';
import {KTApp} from "@/plugins/core/app";

export default {
    components: {
        PageTitle,
        'main-content': mainContent,
        'money-request-form': Form
    },
    computed: {
        ...mapGetters('gateway', [
            'gateways', 'status'
        ]),
        ...mapGetters('pardakhtShakhsi', [
            'form_data',
        ]),
        gateway_didnt_set_in_pardakht_shakhsi() {
            return (this.form_data.shop_id == null);
        },
        gateway_which_set_in_pardakht_shakhsi_is_not_active() {
            return (this.form_data.shop_status != this.gatewayStatus.ACTIVE);
        },
    },
    data() {
        return {
            gatewayStatus: gatewayStatus,
            showErr:false,
        };
    },
    methods: {
        submitSingleRequest(e, query) {
            let form = $('#single-request-form')
            let btn = $('#form-btn')

            form.validate( {
                rules: {
                    full_name: {
                        required: true
                    },
                    amount: {
                        required: true,
                    },
                    phone: {
                        required: true,
                        minlength: 11,
                        digits: true
                    },
                    description: {
                        maxlength: 200,
                    },
                    payment_method: {
                        required: true
                    },
                }
            })

            if (!form.valid())
                return;

            let descrition = query.description;
            if(descrition == undefined || descrition == 'undefined') {
                descrition = '';
            }


            let params = {
                full_name: query.full_name,
                phone: query.phone,
                amount: query.amount,
                description: descrition,
                payment_method: query.payment_method
            }
            KTApp.progress(btn)
            moneyRequestService.create(params).then(response => {
                this.showMsg(form, 'success', response.data.message);
                this.$router.push('/money-request');
            }).catch(({response}) => {
                if(response.data) {
                        this.showMsg(form, 'danger',response.data.message)
                    if (response.data.data.fail_reason == "not_enough_charge") {
                        let message = String(response.data.message) + '<a class="btn mx-2 p-1" href="/user-setting/sms" style="background: #dedede; color: #000" target="_blank">' + i18n.t('notification.label.recharge') + '</a>';
                        this.showMsg(form, 'danger', message);
                    } else {
                        this.showErr = true
                        setTimeout(()=>{
                            this.showErr = false
                        },6000)
                        form.validate().showErrors(response.data.data);
                    }
                }
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        submitGroupRequest(e, query) {
            let form = $('#gregarious-request-form')
            let btn = $('#excel-form-btn')

            form.validate( {
                rules: {
                    file: {
                        required: true
                    },
                    payment_method: {
                        required: true
                    },
                }
            })

            if (!form.valid())
                return;

            let params = {
                file: query.file,
                payment_method:query.payment_method
            }
            KTApp.progress(btn)

            moneyRequestService.create(params).then(response => {
                this.showMsg(form, 'success', response.data.message);
                this.$router.push('/money-request');
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
                this.showErr = true
            }).finally(() => {
                KTApp.unprogress(btn)
            });
        },
        backToMoneyRequestsList() {
            this.$router.push('/money-request')
        },
        activeGateways() {
            var active_gateways = []

            if (!this.gateways || this.gateways.length < 1) {
                active_gateways.has_gateway = false
                return active_gateways
            }

            active_gateways.has_gateway = true

            active_gateways.gates = []
            active_gateways.has_active_gateway = false
            var gateway
            for (gateway of this.gateways) {
                if ((gateway.status === 1 || gateway.status === '1') && gateway.gateway_type === gatewayTypes.PARDAKHTYARI) {
                    active_gateways.gates.push(gateway)
                    active_gateways.has_active_gateway = true
                }

            }

            return active_gateways
        },
    },
    mounted() {
        this.$store.dispatch('gateway/fetch');
        this.$store.dispatch('pardakhtShakhsi/fetch');
    }
}
</script>
